import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import { Link } from "gatsby";

const Logo = () => {
  const data = useStaticQuery(graphql`
    query {
      logoBlack: file(relativePath: { eq: "logo/take-shape-header-logo.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);
  return (
    <>
      <Link color="inherit" to={`/`}>
        <Img
          fluid={data.logoBlack.childImageSharp.fluid}
          style={{
            width: "30vw",
            maxWidth: "225px",
            minWidth: 150,
            display: "inline-block",
            marginTop: 3,
          }}
          imgStyle={{
            objectFit: "contain",
          }}
        />
      </Link>
    </>
  );
};

export default Logo;
